import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_service/authentication.service';
import { BusinessService } from '../_service/business.service';
import {LoginResponseModel} from '../models/LoginResponse.model';
import {Router} from '@angular/router';
import {catchError, of} from 'rxjs';
import {Business} from '../models/business.model';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginFailed: boolean = false;
  pageLoaded: boolean = false;
  loggingIn: boolean = false;

  constructor(private router: Router,private titleService: Title, private authService: AuthenticationService, private businessService: BusinessService) {
    titleService.setTitle('Login to TimeTap Back Office App');
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      userName: new FormControl('', { validators: [Validators.required] }),
      password: new FormControl('', { validators: [Validators.required] }),
    });
    if(localStorage.getItem('token')) {
      this.authService.checkValidSession().subscribe((loginResponse: LoginResponseModel) => {
          if (loginResponse !== null && loginResponse.error !== null) {
            this.businessService.getBusinessForUser().subscribe((business: Business)=>{
              this.businessService.setBusiness(business);
              this.authService.authenticatedSuccessfully(loginResponse, true);
            });
          } else {
            localStorage.removeItem('token');
          }
          this.pageLoaded = true;
        })
        catchError(() => {
          this.router.navigate(['/error']);
          return of(false);
        });
    } else {
      this.pageLoaded = true;
    }


  }


  onSubmit() {
    this.loggingIn = true;
    this.authService.login({
      userName: this.loginForm.value.userName,
      password: this.loginForm.value.password,
      source: 'BACKOFFICE',
    })
      .subscribe((loginResponse: LoginResponseModel) => {
        if (loginResponse.loginToken !== undefined && loginResponse.loginToken !== null &&
          !loginResponse.error) {
          this.loginFailed = false;
          this.authService.authenticatedSuccessfully(loginResponse, false);
          this.businessService.getBusinessForUser().subscribe((business: Business)=>{
            this.businessService.setBusiness(business);
            this.router.navigate(['account-management']);
          });
        } else {
          this.loggingIn = false;
          this.loginFailed = true;
        }
      });
  }
}
